import GooglePlayBadge from 'assets/google-play-store-badge.svg';
import AppleStoreBadge from 'assets/apple-app-store-badge.svg';
import { useIntl } from '@leagueplatform/locales';
import { EXTERNAL_LINKS } from 'common/links';
import {
  AssetLinkProps,
  FooterLinkProps,
} from '@leagueplatform/solutions-foundation';

export const useAppFooterLinks = () => {
  const { formatMessage } = useIntl();

  const footerLinks: FooterLinkProps[] = [
    {
      text: formatMessage({ id: 'STR_FOOTER_PRIVACY_POLICY' }),
      url: EXTERNAL_LINKS.PRIVACY,
    },
    {
      text: formatMessage({ id: 'STR_FOOTER_TERMS_OF_SERVICE' }),
      url: EXTERNAL_LINKS.TERMS,
    },
  ];

  const appDownloadLinks: AssetLinkProps[] = [
    {
      src: AppleStoreBadge,
      url: EXTERNAL_LINKS.APPLE_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_APP_STORE' }),
    },
    {
      src: GooglePlayBadge,
      url: EXTERNAL_LINKS.GOOGLE_PLAY_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_GOOGLE_PLAY' }),
    },
  ];

  return {
    footerLinks,
    appDownloadLinks,
  };
};
